import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as filters from './filters';
import request from './utils/request';

import 'amfe-flexible'
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
  preLoad: 1.3,//距离当前dom距离页面底部的高度
  error: '',//加载失败显示的图片
  loading: '',//加载中显示的图片
  attempt: 1 // 图片加载失败，最多重试的次数
});

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$isWeChat = /MicroMessenger/.test(window.navigator.userAgent);
Vue.prototype.$http = request;

import { Toast,NavBar,Dialog  } from 'vant';
Vue.use(Toast).use(NavBar).use(Dialog);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
